import { render, staticRenderFns } from "./ItemWorkOrdersTable.vue?vue&type=template&id=18356fd1&"
import script from "./ItemWorkOrdersTable.vue?vue&type=script&lang=js&"
export * from "./ItemWorkOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports